 import React from "react";
import { useGetUsersQuery, useChangeUserRoleMutation } from '../../redux/api/coachApi';

export default function StatutUsers() {
  const { data: usersResponse, isLoading, isError, error } = useGetUsersQuery();
  const [changeUserRole, { isLoading: isChanging }] = useChangeUserRoleMutation();
  
  // Extraire les données utilisateurs de la réponse
  const users = usersResponse?.data || [];
  
  const handleRoleChange = async (userId, newRole) => {
    try {
      await changeUserRole({ userId, role: newRole }).unwrap();
      console.log(`Rôle de l'utilisateur ${userId} changé vers ${newRole}`);
    } catch (error) {
      console.error('Erreur lors du changement de rôle:', error);
      alert('Erreur lors du changement de rôle');
    }
  };

  console.log('Users response:', usersResponse);
  console.log('Users:', users);

  if (isLoading) return <div className="p-4">Chargement des utilisateurs...</div>;
  
  if (isError) {
    console.error('Erreur API:', error);
    return (
      <div className="p-4 text-red-600">
        Erreur lors du chargement des utilisateurs: {error?.data?.message || error?.message || 'Erreur inconnue'}
      </div>
    );
  }

  if (!users || users.length === 0) {
    return (
      <div className="p-4">
        <h2 className="text-xl font-bold mb-4">Gestion des utilisateurs</h2>
        <p>Aucun utilisateur trouvé.</p>
      </div>
    );
  }

  return (
    <div className="p-4">
      <h2 className="text-xl font-bold mb-4">Gestion des utilisateurs</h2>
      <table className="min-w-full bg-white border border-gray-300">
        <thead>
          <tr className="bg-gray-100">
            <th className="py-2 px-4 border-b">Nom</th>
            <th className="py-2 px-4 border-b">Email</th>
            <th className="py-2 px-4 border-b">Rôle</th>
            <th className="py-2 px-4 border-b">Action</th>
          </tr>
        </thead>
        <tbody>
          {users.map(user => (
            <tr key={user.id} className="border-b hover:bg-gray-50">
              <td className="py-2 px-4">
                {user.firstName} {user.lastName}
              </td>
              <td className="py-2 px-4">{user.email}</td>
              <td className="py-2 px-4">
                {user.is_admin
                  ? "Admin"
                  : user.is_coach
                  ? "Coach"
                  : "Utilisateur"}
              </td>
              <td className="py-2 px-4">
                <select
                  className="border rounded px-2 py-1 bg-white"
                  value={
                    user.is_admin
                      ? "admin"
                      : user.is_coach
                      ? "coach"
                      : "user"
                  }
                  onChange={e => handleRoleChange(user.id, e.target.value)}
                  disabled={isChanging}
                >
                  <option value="user">Utilisateur</option>
                  <option value="coach">Coach</option>
                  <option value="admin">Admin</option>
                </select>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
      
      {isChanging && (
        <div className="mt-4 text-blue-600">
          Modification en cours...
        </div>
      )}
    </div>
  );
}